import React from "react";
import { OrderedListOutlined } from "@ant-design/icons";
import { DataTable } from "./DataTable";
import { Button } from "antd";
import { useMarketingListModel } from "../allMemberMarketingListModel";
import { YhBox } from "@src/components/YhBox";
import { YhAuth } from "@src/components/auth/YhAuth";
import { EditModeType } from "@src/types/FmsTypes";

export const DataBox = () => {
    const { onReset, setDrawerVisible, setEditType} = useMarketingListModel();
    const onDetail = (type: EditModeType) => {
            setDrawerVisible(true)
            setEditType(type)
        }


    const action = (
        <>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={onReset}
            >刷新</Button>
        </>
    );

    return (
        <YhBox title={<OrderedListOutlined />} action={action}>
            <DataTable />
        </YhBox>
    )
}